import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  ReorderEstimateSectionsMutation as ReorderEstimateSectionsMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const ReorderEstimateSectionsMutation = graphql(`
  mutation ReorderEstimateSections($estimateId: ID!, $sectionIds: [ID!]!) {
    reorderEstimateSections(estimateId: $estimateId, sectionIds: $sectionIds) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

type Variables = {
  sectionIds: Array<Scalars['ID']['input']>;
};

const useReorderEstimateSections = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    ReorderEstimateSectionsMutationResult,
    Error,
    Variables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<ReorderEstimateSectionsMutationResult, Error, Variables>({
    mutationFn: ({ sectionIds }) => {
      return gqlClient.request(ReorderEstimateSectionsMutation, {
        estimateId,
        sectionIds,
      });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.reorderEstimateSections,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useReorderEstimateSections;
